var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form" }, [
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("input-text", {
          ref: "coNmad",
          attrs: {
            id: "coNmad",
            value: _vm.data.coNmad,
            "label-i18n": "MPRS-01-01-05-06",
            placeholder: "MPRS-01-01-05-06",
            maxlength: 10,
            "err-msg-param": { filed: _vm.$t("MPRS-01-01-05-06"), max: 10 },
            toLowerCase: ""
          },
          on: {
            "update:value": function($event) {
              return _vm.$set(_vm.data, "coNmad", $event)
            }
          }
        })
      ],
      1
    ),
    _c("div", { staticClass: "form-row" }, [
      _c(
        "div",
        { staticClass: "item-tit" },
        [
          _vm._v(" " + _vm._s(/*상세 주소*/ _vm.$t("MPRS-01-01-05-07")) + " "),
          _c("required")
        ],
        1
      ),
      _c("div", { staticClass: "item-desc" }, [
        _c("div", { staticClass: "form-text-field" }, [
          _c(
            "div",
            { staticClass: "input-text-field address" },
            [
              _c("input-text", {
                ref: "coAddr1",
                attrs: {
                  id: "coAddr1",
                  value: _vm.data.coAddr1,
                  placeholder: "MPRS-01-01-05-07",
                  maxlength: 66,
                  "err-msg-param": {
                    filed: _vm.$t("MPRS-01-01-05-07"),
                    max: 66
                  },
                  required:
                    _vm.$config.SITECODE_OGCBD +
                    "|" +
                    _vm.$config.SITECODE_OGHCM +
                    "|" +
                    _vm.$config.SITECODE_OGMMR,
                  toLowerCase: ""
                },
                on: {
                  "update:value": function($event) {
                    return _vm.$set(_vm.data, "coAddr1", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "input-text-field" },
            [
              _c("input-text", {
                ref: "coAddr2",
                attrs: {
                  id: "coAddr2",
                  value: _vm.data.coAddr2,
                  maxlength: 66,
                  "err-msg-param": {
                    filed: _vm.$t("MPRS-01-01-05-07"),
                    max: 66
                  },
                  toLowerCase: ""
                },
                on: {
                  "update:value": function($event) {
                    return _vm.$set(_vm.data, "coAddr2", $event)
                  }
                }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("input-text", {
          ref: "coAddr3",
          attrs: {
            id: "coAddr3",
            value: _vm.data.coAddr3,
            "label-i18n": "MPRS-01-01-05-08",
            placeholder: "MPRS-01-01-05-08",
            toLowerCase: ""
          },
          on: {
            "update:value": function($event) {
              return _vm.$set(_vm.data, "coAddr3", $event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }